Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _utils = require("../../utils");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var _ref$childrenCount = _ref.childrenCount,
    childrenCount = _ref$childrenCount === void 0 ? 1 : _ref$childrenCount,
    _ref$maxItemWidth = _ref.maxItemWidth,
    maxItemWidth = _ref$maxItemWidth === void 0 ? _styles.STYLES.grid.maxBoxWidth : _ref$maxItemWidth,
    _ref$isOverflowVisibl = _ref.isOverflowVisible,
    isOverflowVisible = _ref$isOverflowVisibl === void 0 ? false : _ref$isOverflowVisibl;
  var _useWindowDimensions = (0, _utils.useWindowDimensions)(),
    width = _useWindowDimensions.width;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    colors = _STYLES$useStyles.colors,
    grid = _STYLES$useStyles.grid,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight;
  var _spacing = 1;
  if (bp.mobile_xs) {
    _spacing = 0.5;
  }
  var rawMaxItemWidth = 0;
  if (_reactNative.Platform.OS === 'web') {
    var _maxItemWidthRem = parseFloat((maxItemWidth != null ? maxItemWidth : 0).toString());
    rawMaxItemWidth = (_maxItemWidthRem + _spacing * 2) * _styles.baseSize;
  } else {
    rawMaxItemWidth = maxItemWidth + (0, _styles.getREM)(_spacing * 2);
  }
  var spacerWidth = 0;
  if (isOverflowVisible && width > rawMaxItemWidth) {
    spacerWidth = (width - rawMaxItemWidth) / 2;
  }
  var _maxContentWidth = rawMaxItemWidth * childrenCount + spacerWidth * 2;
  var container = {
    alignItems: 'center',
    width: '100%'
  };
  var title = {
    textAlign: 'center',
    marginBottom: spacing.l,
    paddingHorizontal: (0, _styles.getREM)(_spacing),
    maxWidth: grid.maxColumnWidth,
    alignSelf: 'center'
  };
  var description = Object.assign({}, fontBold, {
    textAlign: 'center',
    marginBottom: spacing.xl,
    marginTop: _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(spacing.l, ")") : -1 * spacing.l,
    fontSize: fontSize.normal,
    lineHeight: lineHeight.normal,
    color: colors.brand,
    width: '100%',
    paddingHorizontal: (0, _styles.getREM)(_spacing),
    maxWidth: grid.maxColumnWidth,
    alignSelf: 'center'
  });
  var emptyMessage = Object.assign({}, fontRegular, {
    textAlign: 'center',
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    color: colors.brand,
    width: '100%',
    paddingHorizontal: (0, _styles.getREM)(_spacing),
    maxWidth: grid.maxColumnWidth,
    alignSelf: 'center'
  });
  var carousel = {
    width: '100%',
    overflow: 'hidden',
    paddingBottom: spacing.xs
  };
  if (!isOverflowVisible) {
    carousel.maxWidth = rawMaxItemWidth;
  }
  var scrollview = {
    maxWidth: rawMaxItemWidth,
    width: '100%'
  };
  if (isOverflowVisible && _reactNative.Platform.OS !== 'web') {
    scrollview.overflow = 'visible';
  }
  if (isOverflowVisible) {
    scrollview.maxWidth = undefined;
  }
  var scrollContainer = {
    maxWidth: _maxContentWidth,
    paddingBottom: spacing.xxs
  };
  var carouselItem = {
    maxWidth: _reactNative.Platform.OS === 'web' ? "calc(".concat(rawMaxItemWidth, "px - ").concat((0, _styles.getREM)(_spacing * 2), ")") : rawMaxItemWidth,
    width: _reactNative.Platform.OS === 'web' ? "calc(100vw - ".concat((0, _styles.getREM)(_spacing * 2), ")") : Math.min(rawMaxItemWidth, width),
    paddingLeft: (0, _styles.getREM)(_spacing),
    paddingRight: (0, _styles.getREM)(_spacing),
    flexShrink: 0,
    height: '100%',
    display: 'flex'
  };
  if (_reactNative.Platform.OS === 'web') {
    carouselItem.boxSizing = 'content-box';
  }
  var link = {
    marginTop: spacing.normal
  };
  var imageContainer = {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    alignItems: 'flex-end',
    justifyContent: 'center'
  };
  var targetSize = 300;
  var target = {
    width: targetSize,
    height: targetSize,
    marginRight: (0, _styles.getREM)(_spacing)
  };
  if (bp.desktop_s) {
    var _targetScaleWidth = spacerWidth - _spacing * _styles.baseSize * 2;
    var _scale = Math.min(1, _targetScaleWidth / targetSize);
    target.transform = [{
      translateX: targetSize / 2
    }, {
      scale: _scale
    }, {
      translateX: -1 * (targetSize / 2)
    }];
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    scrollview: scrollview,
    scrollContainer: scrollContainer,
    title: title,
    description: description,
    emptyMessage: emptyMessage,
    carousel: carousel,
    carouselItem: carouselItem,
    link: link,
    imageContainer: imageContainer,
    target: target
  });
  return {
    styles: styles,
    spacerWidth: spacerWidth,
    rawMaxItemWidth: rawMaxItemWidth,
    pageWidth: width,
    targetSize: targetSize
  };
};